// extracted by mini-css-extract-plugin
export default {"root":"_McCFELv6p"};